<template>
  <component
    :is="tagName"
    class="paragraphBase"
    :class="classString"
    :style="cssString"
    @input="updateComponent"
    v-html="$t(html)"
    ref="paragraph"
  />
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "paragraph",
  props: {
    text: {
      type: String,
      default: "Empty paragraph"
    },
    grid: {
      type: Object,
      default: () => ({
        backgroundColor: "#fff"
      })
    },
    actions: {
      type: Array,
      default: () => {
        return  []
      }
    },
    variables: Object,
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    classes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      cssString: "",
      classString:""
    };
  },
  mounted () {
    if (this.actions.length > 0) {
      this.$refs.paragraph.addEventListener('click', this.triggerActions)
      this.$refs.paragraph.addEventListener('keypress', (e) => {
        if (e.keyCode == 13) {
          e.preventDefault();
          this.triggerActions();
        }
      })
      this.$refs.paragraph.setAttribute('tabindex', 0)
    }
  },
  computed: {
    html () {
      let result = this.text;
      if (this.variables) {
        for (const variable in this.variables) {
          let value = this.$store.state.formData[variable];
          if(variable === "referenceNumber") {
            value = this.$store.getters.getReferenceNumber
          }
          result = result.replace(new RegExp(`{${variable}}`, "g"), value);
        }
      }
      return result;
    },
    tagName () {
      // Prefer real HTML headings for accessibility.
      // Existing UI uses 'heading' for main section headings and 'subHeading' for sub-sections.
      if (this.classes?.includes('heading')) return 'h2';
      if (this.classes?.includes('subHeading')) return 'h3';
      return 'p';
    }
  },
  watch: {
    styles: {
      immediate: true,
      handler () {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
      }
    },
    classes: {
      immediate: true,
      handler () {
        this.classes.forEach(cls=>{
          this.classString += cls+" ";
        })
      }
    }
  },
  methods: {
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000),
    triggerActions () {
      if (this.actions) {
        this.actions.forEach(action => {
          const fn = action.fn;
          const params = action.params;
          this[fn](params, this);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraphBase {
  outline: 0;
}

.heading {
  font-weight: 800;
  font-size: 48px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: var(--text-color-2);
  opacity: 1;
  margin: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;

  &.topPadding {
    padding-top: 192px;

    @media (max-width: 575px) {
      padding-top: 60px;
    }
  }
}

.subHeading {
  font-size: 24px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: var(--text-color-4);
  opacity: 1;
  margin: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.subText {
  font-size: 16px;
  line-height: 1.625;
  color: #474747;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.loginSubText {
  text-align: center;
  text-decoration: underline;
  font-family: Montserrat, Medium, sans-serif;
  font-size: 20px;
  line-height: 1.5;
  font-weight: 500;
  letter-spacing: 0px;
  color: #000;
  opacity: 1;
  padding: 0px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.stepCard {
  margin-top: 10px;

  color: #1A1111;
  text-align: center;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 545px) {
    font-size: calc(100vw / 545 * 14 + 2px);
  }

}

@media (max-width: 991px) {

  .heading {
    font-size: 24px;
    line-height: 1.5;
  }
  .subHeading {
    font-size: 16px;
    line-height: 1.5;
  }

  .desktop-only {
    display: none !important;
  }
}

</style>
